(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axolove-mobile-shop-nav"] && !Shopify.designMode) return;
  try {
    
  class AxoloveMobileShopNav extends HTMLElement {
    connectedCallback() {
      this.handleNavClick = this.handleNavClick.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleIntent = this.handleIntent.bind(this);
      this.prefetchedUrls = new Set();
      const connection = navigator.connection;
      this.prefetchEnabled =
        window.matchMedia('(max-width: 989px), (hover: none)').matches &&
        HTMLScriptElement.supports?.('speculationrules') &&
        window.Shopify?.theme?.role === 'main' &&
        !connection?.saveData &&
        !connection?.effectiveType?.includes('2g');

      this.addEventListener('click', this.handleNavClick);
      this.addEventListener('pointerover', this.handleIntent, { passive: true });
      this.addEventListener('focusin', this.handleIntent);
      this.addEventListener('touchstart', this.handleIntent, { passive: true });
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeydown);

      queueMicrotask(() => {
        this.warmLinks(this.querySelectorAll('.axolove-mobile-shop-nav__items a[href]'), 4);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleNavClick);
      this.removeEventListener('pointerover', this.handleIntent);
      this.removeEventListener('focusin', this.handleIntent);
      this.removeEventListener('touchstart', this.handleIntent);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleKeydown);
    }

    handleNavClick(event) {
      const trigger = event.target.closest('[data-mobile-shop-nav-trigger]');
      if (!trigger || !this.contains(trigger)) return;

      const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
      this.closeAll();

      if (shouldOpen) {
        const panel = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.hidden = false;
          this.warmLinks(panel.querySelectorAll('a[href]'), 6);
        }
      }
    }

    handleIntent(event) {
      const link = event.target.closest('a[href]');
      if (link && this.contains(link)) this.warmLinks([link], 1);

      const trigger = event.target.closest('[data-mobile-shop-nav-trigger]');
      if (!trigger || !this.contains(trigger)) return;

      const panel = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
      if (panel) this.warmLinks(panel.querySelectorAll('a[href]'), 6);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) this.closeAll();
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;

      const openTrigger = this.querySelector('[data-mobile-shop-nav-trigger][aria-expanded="true"]');
      if (!openTrigger) return;

      this.closeAll();
      openTrigger.focus();
    }

    closeAll() {
      this.querySelectorAll('[data-mobile-shop-nav-trigger]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      this.querySelectorAll('[data-mobile-shop-nav-panel]').forEach((panel) => {
        panel.hidden = true;
      });
    }

    warmLinks(links, limit) {
      if (!this.prefetchEnabled) return;

      const currentPath = `${window.location.pathname}${window.location.search}`;
      const urls = [...links]
        .map((link) => new URL(link.href, window.location.href))
        .filter((url) => url.origin === window.location.origin && url.pathname.startsWith('/collections/'))
        .map((url) => `${url.pathname}${url.search}`)
        .filter((url) => url !== currentPath && !this.prefetchedUrls.has(url))
        .slice(0, limit);

      if (!urls.length) return;

      urls.forEach((url) => this.prefetchedUrls.add(url));
      const rules = document.createElement('script');
      rules.type = 'speculationrules';
      rules.textContent = JSON.stringify({ prefetch: [{ urls, eagerness: 'immediate' }] });
      document.head.append(rules);
    }
  }

  if (!customElements.get('axolove-mobile-shop-nav')) {
    customElements.define('axolove-mobile-shop-nav', AxoloveMobileShopNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
